import { Controller } from "stimulus";

export default class extends Controller {
  static tooltipBox = null;

  connect() {
    if (!this.constructor.tooltipBox) {
      const tooltip = document.createElement("div");
      tooltip.className = "syos-tooltip-box";
      document.body.appendChild(tooltip);
      this.constructor.tooltipBox = tooltip;
    }
  }

  show(event) {
    const tooltip = this.constructor.tooltipBox;
    tooltip.textContent = event.currentTarget.dataset.tooltip;
    tooltip.style.opacity = "1";

    const rect = event.currentTarget.getBoundingClientRect();
    const scrollY = window.scrollY;
    const scrollX = window.scrollX;

    const centerX = rect.left + rect.width / 2 + scrollX;
    const centerY = rect.top + rect.height / 2 + scrollY;

    // Ensure tooltip has measured its dimensions before positioning
    requestAnimationFrame(() => {
      const tooltipWidth = tooltip.offsetWidth;
      const tooltipHeight = tooltip.offsetHeight;

      tooltip.style.left = `${centerX - tooltipWidth / 2}px`;
      tooltip.style.top = `${centerY - tooltipHeight / 2}px`;
    });
  }

  hide() {
    this.constructor.tooltipBox.style.opacity = "0";
  }
}
